import React from "react";
import { Box } from "@mui/material";
import AppVersionManagement from "../components/settings/appVersion/AppVersionManagement";

function AppVersionSettings() {
  return (
    <Box>
      <AppVersionManagement />
    </Box>
  );
}

export default AppVersionSettings;
